import { CREATE_FREE_GAME } from './constants';

export function createFreeGame(payload) {
  return {
    type: CREATE_FREE_GAME,
    payload
  }
}
